export enum StatutNotificationEnum {
    Created = 'created',
    Viewed = 'viewed',
    Closed = 'closed'
}
